goog.provide("shadow.js.shim.module$$mui$material$DialogTitle$default");
shadow.js.shim.module$$mui$material$DialogTitle$default = shadow.js.shim.module$$mui$material$DialogTitle.default;
